module.exports = __webpack_public_path__ + "media/icons/quote-678d6285.png";